// Commissioners
import KangRikiImg from "@/assets/images/landing_page/img-kang-riki.png";
import PakSuyadiImg from "@/assets/images/landing_page/img-pak-suyadi.png";
import PakFajriImg from "@/assets/images/landing_page/img-pak-fajri.png";
import PakDjunaediImg from "@/assets/images/landing_page/img-pak-djunaedi.png";

// Management
import KangKrisnaImg from "@/assets/images/landing_page/img-kang-krisna.png";
import TehPutriImg from "@/assets/images/landing_page/img-teh-putri.png";

// Sharia Advisor
import KangFachryImg from "@/assets/images/landing_page/img-kang-fachry.png";

export const efundingHierarchy = {
  commissioners: [
    {
      id: 1,
      name: "Maulana Riki Alamsyah",
      position: "Komisaris Utama",
      imageSrc: KangRikiImg,
    },
    {
      id: 2,
      name: "Suyadi",
      position: "Komisaris",
      imageSrc: PakSuyadiImg,
    },
    {
      id: 3,
      name: "Fajri Sentosa",
      position: "Komisaris",
      imageSrc: PakFajriImg,
    },
    {
      id: 4,
      name: "Djunaedi Hermawanto",
      position: "Komisaris",
      imageSrc: PakDjunaediImg,
    },
  ],
  management: [
    {
      id: 1,
      name: "Krisna Satria Gunawan",
      position: "CEO",
      imageSrc: KangKrisnaImg,
    },
    {
      id: 2,
      name: "Wuliandari Tri Putri",
      position: "COO",
      imageSrc: TehPutriImg,
    },
  ],
  advisor: [
    {
      id: 1,
      name: "Muhammad Fachry Maulana",
      position: "Sharia Advisor",
      imageSrc: KangFachryImg,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/utils/efunding_hierarchy.js